interface IconProps {
  ariaLabel?: string
}

const defaultProps: Partial<IconProps> = {
  ariaLabel: '',
}

export const PlayIcon: React.FC<IconProps> = ({ariaLabel} = defaultProps) => {
  return (
    <svg
      aria-label={ariaLabel}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M14.3422 6.87315C15.2193 7.36162 15.2193 8.63838 14.3422 9.12685L5.88073 13.8391C5.03482 14.3102 4 13.6902 4 12.7123L4 3.28772C4 2.30979 5.03482 1.68977 5.88073 2.16087L14.3422 6.87315Z"
      />
    </svg>
  )
}

export const PauseIcon: React.FC<IconProps> = ({ariaLabel} = defaultProps) => {
  return (
    <svg
      aria-label={ariaLabel}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M5 2H6C6.26522 2 6.51957 2.10536 6.70711 2.29289C6.89464 2.48043 7 2.73478 7 3V13C7 13.2652 6.89464 13.5196 6.70711 13.7071C6.51957 13.8946 6.26522 14 6 14H5C4.73478 14 4.48043 13.8946 4.29289 13.7071C4.10536 13.5196 4 13.2652 4 13V3C4 2.73478 4.10536 2.48043 4.29289 2.29289C4.48043 2.10536 4.73478 2 5 2ZM10 2H11C11.2652 2 11.5196 2.10536 11.7071 2.29289C11.8946 2.48043 12 2.73478 12 3V13C12 13.2652 11.8946 13.5196 11.7071 13.7071C11.5196 13.8946 11.2652 14 11 14H10C9.73478 14 9.48043 13.8946 9.29289 13.7071C9.10536 13.5196 9 13.2652 9 13V3C9 2.73478 9.10536 2.48043 9.29289 2.29289C9.48043 2.10536 9.73478 2 10 2Z"
      />
    </svg>
  )
}

try{ PlayIcon.displayName ||= 'PlayIcon' } catch {}
try{ PauseIcon.displayName ||= 'PauseIcon' } catch {}